module.exports = __webpack_public_path__ + "img/icon5.5b81e88.webp";